import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Learning",
  "lead": "在撒哈拉以南非洲地区，至少 15 个国家中超过一半的学生在小学教育结束时未达到最低阅读水平。"
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, HighlightByIndex, IndicatorReference, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_LEARNING"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "仅仅让孩子入学是不够的。在不妨碍学校所承担和必须追求的其他许多有价值的目标的前提下，学生需要具备阅读能力并掌握基础数学技能。这些是其他学习、个人赋权和福祉以及获取社会、政治和经济成果的基础。"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "儿童和青年",
      children: "儿童和青年"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.1",
      label: "4.1.1a",
      children: [_jsxs(_components.p, {
        children: ["在一些世界上最贫穷国家中，许多儿童缺乏基本的阅读和数学技能。\n尼日利亚北部各州（例如卡杜纳州和索科托州）以及赤道省和加丹加省等刚果民主共和国省份的低年级阅读评估结果表明，超过 80％ 的小学三年级学生甚至看不懂关联文本中的", _jsx(_components.strong, {
          children: "单个单词"
        }), "。"]
      }), _jsx(Figure, {
        id: "EGRA"
      })]
    }), "\n", _jsx(_components.p, {
      children: "该数据不包括未上学的儿童。在人们家中开展的调查可以了解上学和未上学儿童的技能水平。"
    }), "\n", _jsx(_components.p, {
      children: "例如，下图以公民自主评估为基础，反应了巴基斯坦和印度农村不同地区的情况。"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(HighlightByIndex, {
        index: "1",
        children: "红线"
      }), "显示了按年级划分的", _jsx(_components.strong, {
        children: "在校"
      }), "儿童具有基本阅读技能的孩子的百分比，而", _jsx(HighlightByIndex, {
        index: "0",
        children: "蓝线"
      }), "显示了按年级对应年龄划分（", _jsx(_components.strong, {
        children: "无论是否在校"
      }), "）的所有具有基本阅读技能的孩子的百分比。"]
    }), "\n", _jsx(_components.p, {
      children: "这两条线之间的差距提醒着人们，在失学率高的国家，如果决策者仅监测在校学生的学习情况，那么他们只能获得片面的数据。值得注意的是，监测到的技能水平非常低。即使在成绩最好的地区，至少也有一些中学生无法阅读二年级水平的文本。"
    }), "\n", _jsx(Figure, {
      id: "LEARN_AGE_GRADE"
    }), "\n", _jsx(IndicatorReference, {
      id: "4.1.1",
      label: "4.1.1b",
      children: _jsx(_components.p, {
        children: "据估计，将近 40％ 的小学年龄段的儿童不具备基本的阅读技能。撒哈拉以南非洲地区有 70％ 的儿童也是如此，但在欧洲和北美地区，这一比例仅为 3％。"
      })
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.0",
      label: "4.1.0",
      children: [_jsx(_components.p, {
        children: "在许多国家，即使儿童完成了小学教育，也无法保证他们具备阅读能力。在全球范围内，有四成的小学毕业生不具备基本的阅读技能。如下图所示，在低收入国家，这一比例更是高达八成。"
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "LEARN_REACHFINAL"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: [_jsx(HighlightByIndex, {
              index: "-1",
              children: "灰色部分"
            }), "显示的是完成了小学教育但未达到最低阅读水平的儿童的百分比。", _jsx(HighlightByIndex, {
              index: "1",
              children: "红色部分"
            }), "显示的是完成了小学教育并达到最低阅读水平的学生，", _jsx(HighlightByIndex, {
              index: "0",
              children: "蓝色部分"
            }), "显示的是没有完成小学教育的儿童。"]
          })
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "从国家层面来看，在乍得和尼日利亚，入学 5、6 年后离开学校的年轻人中，约有 90％ 不能识字。但是，有些国家的情况要好得多。例如，在布隆迪、哥斯达黎加和洪都拉斯，几乎所有五年级或六年级后离开学校的年轻人都能识字。"
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "LITBYYRS"
        })
      }), _jsx(ScrollySection, {
        id: "KEN",
        children: _jsxs(_components.p, {
          children: ["例如，在", _jsx(_components.strong, {
            children: "肯尼亚"
          }), "，在受过", _jsx(HighlightByIndex, {
            index: "1",
            children: "最多 4 年教育"
          }), "的儿童中，有四分之一具备识字能力，但在受过", _jsx(HighlightByIndex, {
            index: "0",
            children: "5-6 年教育"
          }), "的儿童中，这一比例跃升至四分之三，相当于完成小学教育。"]
        })
      }), _jsx(ScrollySection, {
        id: "BFA",
        children: _jsxs(_components.p, {
          children: ["在", _jsx(_components.strong, {
            children: "布基纳法索"
          }), "，几乎没有儿童在受过", _jsx(HighlightByIndex, {
            index: "1",
            children: " 4 年教育后"
          }), "具备阅读能力，但如果他们完成了", _jsx(HighlightByIndex, {
            index: "0",
            children: "全部小学教育"
          }), "，那么超过一半的儿童可掌握基本的读写技能。"]
        })
      })]
    }), "\n", _jsx(_components.p, {
      children: "为了能够比较各国的学习情况，需要将评估和测试结果与采用统一定义的国际标准进行对照。最近针对跨国评估制定了这样的标准，评估中来自多个国家的学生参加同一项测试。但是，目前可用于全国性评估的此类映射较少。"
    }), "\n", _jsx(_components.p, {
      children: "其中一项评估是国际数学与科学趋势研究 (TIMSS)，每四年进行一次，让我们能够观察到四年级和八年级学生随时间取得的进步。它显示了进展特别缓慢的地方。例如，在埃及，八年级学生中达到最低数学水平的比例从 2003 年的 24％ 仅增加到 2019 年的 27％。"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(HighlightByIndex, {
        index: "0",
        children: "马来西亚"
      }), "等一些国家的学生达到最低学习水平的学生比例甚至随着时间的推移出现了下降。"]
    }), "\n", _jsxs(_components.p, {
      children: ["而在", _jsx(HighlightByIndex, {
        index: "1",
        children: "巴林"
      }), "等其他国家，进展迅速 — 在 2003 年至 2019 年间，达到最低能力水平的学生比例增长了两倍多。"]
    }), "\n", _jsx(Figure, {
      id: "PIRLSGAIN"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.1",
      label: "4.1.1b",
      children: [_jsx(_components.p, {
        children: "与大多数人的预期相反，性别学习差距并不大 — 例如，在小学教育阶段，几乎所有国家的性别学习差距都不超过十个百分点。"
      }), _jsx(_components.p, {
        children: "但是国家之间的学习差距却十分巨大。在撒哈拉以南非洲国家，其小学教育中的阅读技能往往处于较低水平，达到最低能力水平的学生比例从布隆迪的 4％ 到加蓬的 76％ 不等（均来自 2019 年的 PASEC 评估结果）。"
      }), _jsx(_components.p, {
        children: "在东南亚国家的小学数学教育方面，达到最低能力水平的学生比例从老挝人民民主共和国的 8％ 到越南的 91％ 不等（均来自 2019 年的 SEA-PLM 评估结果）。"
      }), _jsx(Figure, {
        id: "ASSESS"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "成人",
      children: "成人"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.6.2",
      children: [_jsx(_components.p, {
        children: "在 2000 年至 2023 年之间，全球具备识字能力的成年人比例从 81％ 增加到了 87％，而具备识字能力的青少年比例从 87％ 增加到了 93％。"
      }), _jsx(_components.p, {
        children: "尽管取得了这些进展，但文盲现象在许多国家仍然很普遍，尤其是在女性群体中。在拉丁美洲和加勒比地区，识字率停滞在较高水平上，这反映存在一些处于极度不利地位的“难以触及”的群体。例如，在厄瓜多尔，农村地区成年女性的识字率在过去 10 年间没有太大变化，约为 83％。"
      }), _jsx(_components.p, {
        children: "在撒哈拉以南非洲地区，超过 40％ 的成年女性（25-64岁）无法阅读。在许多国家，识字率要么停滞在极低的水平，例如马里，只有不到 17％ 的人能阅读，要么进展缓慢，如坦桑尼亚联合共和国，十年来识字率从 72％ 仅提高到 77％。"
      }), _jsx(_components.p, {
        children: "在全球范围内，如果说现在的成年人识字率相比过去有所提升，那主要是因为有更多的成年人在年轻时上了学，而不是因为没有上学的成年人获得了再学习的机会。为了证实这一说法，下图显示了给定群组（或群体）随着年龄增长其读写能力的变化数据。"
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "LITCOHORT"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["在大多数国家，由于技能未得到充分利用，特定", _jsx(HighlightByIndex, {
              index: "0",
              children: "成年群体"
            }), "的识字率会随着时间的推移发生停滞甚至下降。"]
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["在", _jsx(_components.strong, {
              children: "布基纳法索"
            }), "，蓝线显示", _jsx(HighlightByIndex, {
              index: "0",
              children: "2003 年 20–34 岁的女性"
            }), "、", _jsx(HighlightByIndex, {
              index: "0",
              children: "2010 年 27-41 岁的女性"
            }), "以及", _jsx(HighlightByIndex, {
              index: "0",
              children: " 2021 年 38–62 岁的女性"
            }), "的识字率保持相对稳定。但是，由于越来越多的年轻女性开始识字，红线显示", _jsx(HighlightByIndex, {
              index: "1",
              children: "20-34 岁女性的识字率"
            }), "随着时间的推移在不断提高。"]
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.6.1",
      children: [_jsx(_components.p, {
        children: "这些评估所衡量的是非常基础的读写能力，主要考察人们是否能够读懂简单的句子。功能性读写能力则是另一回事，指的是人们可以阅读并解释书面指令、正式信函或合同。"
      }), _jsx(_components.p, {
        children: "很少有国际调查会收集功能性读写能力相关数据，更不用说定期收集了。"
      }), _jsx(_components.p, {
        children: "从我们掌握的数据来看，在哥伦比亚和越南，超过十分之一的城市成年人不具备功能性读写能力（即读写水平低于 1 级），而玻利维亚则有四分之一的城市成年人不具备此能力。"
      }), _jsxs(_components.p, {
        children: ["在", _jsx(_components.strong, {
          children: "加纳"
        }), "，即使在城市成年人中，也只有 39％ 具有功能性读写能力。"]
      }), _jsx(Figure, {
        id: "LITPROF"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "结语",
      children: "结语"
    }), "\n", _jsx(_components.p, {
      children: "尽管 SDG 4 已将重点转向对学习的监测上，但许多国家仍为就阅读和数学方面的学习成果指标进行报告。即使是想要开始评估和报告学习情况的国家，也往往面临障碍，致使它们无法采取有效且具有成本效益的解决方案。但是我们所掌握的证据表明，世界上最贫穷国家的大多数学生没有达到最基本技能的最低能力水平。"
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://openknowledge.worldbank.org/handle/10986/32553",
            children: "终结学习贫困 — 需要什么？— 世界银行"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "http://uis.unesco.org/sites/default/files/documents/ip61-combining-data-out-of-school-children-completion-learning-offer-more-comprehensive-view-sdg4.pdf",
            children: "整合失学儿童、学业完成和学习情况数据，以更加全面地了解 SDG 4 — 统计研究所 (UIS)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://unesdoc.unesco.org/ark:/48223/pf0000225660",
            children: "EFA GMR 2013/4：教学与学习：实现高质量全民教育"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://gemreportunesco.wordpress.com/2019/05/20/the-learning-assessment-market-pointers-for-countries-part-2/",
            children: "学习评估市场——各国指引"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
